import { UploadStrategyBase } from './upload-strategy-base';
import { DocService } from '@services/doc.service';
import { FileType } from '@models/file-type';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';
import { map, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class AnnotationUploadStrategy extends UploadStrategyBase {
    public title = 'Manual Annotation';
    public message = 'From here you can upload a document that has been previously annotated outside of eDiscoveryPlatform with Acrobat Pro or another desktop annotation tool. The page count of the annotated document must match the page count of the Normalized PDF (Doc tab). Alternatively, you can use the eDiscoveryPlatform annotation editor to create an annotated version of the document online.  See help for more details.  Upload previously annotated document:';
	private warningIfTranslatedDocumentAlreadyExists = 'Warning: An annotated document already exists. Uploading a new annotated PDF will overwrite existing annotated document.';
	private errorIfCaseIsAlreadyProcessing: string = 'Cannot upload Annotated PDF while document is processing.';

	constructor(protected docService: DocService, protected store: DocViewerStore) {
		super(docService, store);
	}

	public warning$(): Observable<string> {
		return this.store.currentDocument$.pipe(
			map((currentDocument) => currentDocument.status.isAnnotated ? this.warningIfTranslatedDocumentAlreadyExists : '')
		);
	}

	public error$(): Observable<string> {
		return this.store.currentDocument$.pipe(
			map((currentDocument) => currentDocument.status.isAnnotationProcessing ? this.errorIfCaseIsAlreadyProcessing : '')
		);
	}

	public tryUpload(file: File): Observable<string> {
		return this.uploadInternal(file, FileType.AnnotatedPdf);
	}
}
